/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import {
	queryOptions,
	useQuery,
} from '@tanstack/react-query';

// Types
import { TParamsGetApi } from '@global-types/index';

// Lib
import { apiClient } from '@lib/api-client';

// Constants
import { queryKeys } from '@config/constants/query-keys';
import { TAdditionalityProject } from '@global-types/api/api';
import { QueryConfig } from '@lib/react-query';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const getAdditionalities = (
	params: Partial<TParamsGetApi>
): Promise<TApiResponseGetAdditionalities> => {
	return apiClient.get('/additionalities', {
		params,
	});
};

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */

type TApiResponseGetAdditionalities = {
	total: number;
	page: number;
	pageSize: number;
	totalPages: number;
	rows: TAdditionalityProject[];
};

type TUseGetAdditionalitiesOptions = {
	params: Partial<TParamsGetApi>;
	queryConfig?: QueryConfig<typeof getAdditionalities>;
};

/* -------------------------------------------------------------------------- */
/*                                    Helper                                  */
/* -------------------------------------------------------------------------- */
export const getAdditionalitiesQueryOptions = (
	params: Partial<TParamsGetApi> = {}
) => {
	return queryOptions({
		queryKey: params
			? [
					queryKeys.app.additionalities.all.key,
					{ params },
				]
			: [queryKeys.app.additionalities.all.key],
		queryFn: () => getAdditionalities(params),
	});
};

/* -------------------------------------------------------------------------- */
/*                                     Hook                                   */
/* -------------------------------------------------------------------------- */
export const useGetAllAdditionalities = ({
	params,
	queryConfig,
}: TUseGetAdditionalitiesOptions) => {
	return useQuery({
		...getAdditionalitiesQueryOptions(params),
		...queryConfig,
	});
};
